

interface HitData {}
interface HitMethods {}
interface HitComputed {
    defaultImage: string
}
interface HitProps {
    hit: IHit
}

import Vue from 'vue'
import { IHit } from '../store/state'
export default Vue.extend<HitData, HitMethods, HitComputed, HitProps>({
    name: 'HitComponent',
    props: {
        hit: {}
    },
    computed: {
        defaultImage() {
            return this.$store.state.defaultImage;
        }
    }
})
